import React from "react";
import "./UserAgreement.css";
import { useNavigate } from "react-router-dom";

const UserAgreement = () => {
    const navigate = useNavigate();
          const handleAgree = () => {
    navigate(-1); // 👈 goes back to previous route
  };
  return (
    <div className="jayraj-ua-page">
      {/* Floating Blobs */}
      <div className="jayraj-ua-blob jayraj-ua-blob-pink"></div>
      <div className="jayraj-ua-blob jayraj-ua-blob-blue"></div>

      {/* Card */}
      <div className="jayraj-ua-card">
        <h1 className="jayraj-ua-title">Jayraj Group — User Agreement</h1>

        <p className="jayraj-ua-intro">
          Welcome to <strong>Jayraj Group</strong>. By accessing or using our
          services, you agree to comply with and be bound by the following
          terms and conditions.
        </p>

        <ul className="jayraj-ua-list">
          <li>You must be at least 18 years old to use our services.</li>
          <li>You agree not to misuse our services or violate any laws.</li>
          <li>
            We respect your privacy — refer to our <strong>Privacy Policy</strong> for details.
          </li>
          <li>Jayraj Group reserves the right to update these terms at any time.</li>
          <li>
            Continued use of our services constitutes acceptance of these terms.
          </li>
        </ul>

        {/* Button */}
        <div className="jayraj-ua-button-container">
          <button className="jayraj-ua-btn"  onClick={handleAgree}>Accept & Continue</button>
        </div>
      </div>
    </div>
  );
};

export default UserAgreement;
